import {
  GET_GALLRY_IMAGE_REQUEST,
  GET_GALLRY_IMAGE_SUCCESS,
  GET_GALLRY_IMAGE_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  data: {},
  loading: false,
  error: null,
};
export const getGalleryImageReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case GET_GALLRY_IMAGE_REQUEST:
      return {
        ...state,
        data: action.payload,
        loading: true,
        error: null,
      };
    case GET_GALLRY_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_GALLRY_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
